import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
//import Header from 'Components/Header/Header.jsx';
//import WalletBalance from 'Components/WalletBalance/WalletBalance.jsx';
//import useWindowSize from 'Components/useWindowSize';

//import * as S from './SupportRequest.styles';
//import PageHeader from 'Components/PageHeader/PageHeader';
import RefundRequestRaiseContainer from './RefundRaiseRequestContainer/RefundRaiseRequestContainer';
import RefundRaiseRequestPageHeader from './RefundRaiseRequestPageHeader/RefundRaiseRequestPageHeader';
import {userSettingDataSelector, userWalletInfoSelector} from '@ibibo/myaccount-reducer';
import {useAnalyticService} from '@ibibo/analytics-provider';

const RefundRaiseRequest = () => {
  const [showRefundFormFlag, setShowRefundFormFlag] = useState(false);
  const {updateAnalyticDataStore, sendTrackingDataToSdk} = useAnalyticService();
  const userData = useSelector(userSettingDataSelector);
  const walletInfo = useSelector(userWalletInfoSelector);
  const loadPDTTrackingData = ({userData, walletInfo}) => {
    const {account_id, is_sub_user, uuid} = userData;

    const pdtTrackingData = {
      global: {
        payload: {
          campaign_details: {
            campaign_name: 'mypartner_direct',
            campaign_key: 'MYPARTNER',
          },
          event_tracking_context: {
            traffic_source: 'mypartner_direct',
            domain_country: 'india',
            domain_currency: 'INR',
            domain_language: 'eng',
            env: 'prod',
            bu: 'mypartner_core',
            organisation: 'MMT',
            funnel_source: 'mypartner_core',
            topic_name: 'mmt_core_mypartner_pdt_client_logging',
            producer: 'mypartner_core',
            template_id: 179775,
          },
          user_context: {
            user_type: is_sub_user ? 'Sub User' : 'Admin',
            agency_code: account_id?.value,
            profile_type: 'cta',
            uuid: uuid?.value || '',
            is_logged_in: true,
            logging_channel: null,
            wallet_bal: walletInfo?.tb,
          },
        },
      },
      pageLoad: {
        payload: {
          page_context: {
            lob: 'common',
            lob_category: 'common',
            page_title: null,
            page_name: 'depositadmin',
            subpage_name: null,
            site_section: null,
            page_type: 'landing',
            percent_page_viewed: null,
            prev_page_name: null,
            travel_store: null,
            page_url: null,
            funnel_step: 'landing',
            page_state_journey: null,
            sub_lob: 'mypartner_core',
            pg_time_interval: null,
            platform: null,
          },
          coupon_details: null,
          cross_sell_details: null,
          addon_details: null,
          traveller_details_list: null,
          payment_details: null,
          campaign_details: null,
          event_detail: {
            event_name: 'page_entry',
            event_type: 'user_action',
            event_value: 'depositadmin',
            components: null,
            client_travel_store_meta: null,
            interaction_type: null,
            booking_info: null,
          },
        },
      },
    };
    if (pdtTrackingData) {
      updateAnalyticDataStore?.(pdtTrackingData, 'REFUND_RAISE_REQUEST');
      sendTrackingDataToSdk?.(pdtTrackingData, 'REFUND_RAISE_REQUEST');
    }
  };
  useEffect(() => {
    if (userData) {
      loadPDTTrackingData({userData, walletInfo});
    }
  }, [userData]);
  return (
    <React.Fragment>
      {/*
                deviceWidth.width > 766 ? <Header /> : <WalletBalance />
            */}
      <RefundRaiseRequestPageHeader />
      <RefundRequestRaiseContainer sendTrackingDataToSdk={sendTrackingDataToSdk} />
    </React.Fragment>
  );
};

export default RefundRaiseRequest;
